/// <reference path="DOMAttached.js" />
/// <reference path="TextResource.js" />
/// <reference path="UrlTemplate.js" />

var DragonWorldServerInterface = null;

class DragonWorld extends DOMAttached {
	constructor(el, options) {
		super(el, options);

		//DragonHatching
		this.hatchedDragonType = "PLH_hatchedDragonType";
		//CustomizeDragon
		this.dragonHatID = "PLH_dragonHatID";
		this.dragonBeardID = "PLH_dragonBeardID";
		this.dragonColorID = "PLH_dragonColorID";
		//saveDragonStatsAndIncreaseHatchingCounter
		this.dragonStat1 = "PLH_dragonStat1";
		this.dragonStat2 = "PLH_dragonStat2";
		this.dragonStat3 = "PLH_dragonStat3";
		this.dragonStat4 = "PLH_dragonStat4";
		this.dragonStat5 = "PLH_dragonStat5";
		//saveDragonItems
		this.items = "PLH_dragonWorldItemList";
		//save currentChallengePosition
		this.currentChallengePosition = "PLH_dragonWorldCurrentChallengePosition";
		//checkForGold
		this.gold = "PLH_gold";
		//callForMoneyTransaction
		this.goldTag = "PLH_goldTag";
		//saveHighscore
		this.score = "PLH_score";
		this.miniGameID = "PLH_dragonWorldMinigameID";
		//getGameContent and setGamePassed
		this.gameId = "PLH_gameId";
		//resetGamesPassedInCategory
		this.categoryNameTRKey = "PLH_categoryNameTRKey";
		//awardTrophy
		this.trophyId = "PLH_trophyId";
		this.trophyColor = "PLH_trophyColor";
		DragonWorldServerInterface = this;
	}

	resetHatchingCounterAndAddHatchedDragon(type) {
		axios(new UrlTemplate(this.options.hatchedDragonUrl)
		.r(this.hatchedDragonType, type)
		.url, {
			method: 'get'
		});
	}

	customizeDragon(hatID, beardID, colorID) { //, onTrueCallback, onFalseCallback){
		axios(new UrlTemplate(this.options.customizeUrl)
		.r(this.dragonHatID, hatID)
		.r(this.dragonBeardID, beardID)
		.r(this.dragonColorID, colorID)
		.url, {
			method: 'get'
		});
	}

	saveDragonStatsAndIncreaseHatchingCounter(stat1, stat2, stat3, stat4, stat5) { //, onTrueCallback, onFalseCallback){
		axios(new UrlTemplate(this.options.statsUrl)
		.r(this.dragonStat1, stat1)
		.r(this.dragonStat2, stat2)
		.r(this.dragonStat3, stat3)
		.r(this.dragonStat4, stat4)
		.r(this.dragonStat5, stat5)
		.url, {
			method: 'get'
		});
	}

	storeItems(items) {
		axios(new UrlTemplate(this.options.itemUrl)
		.r(this.items, items)
		.url, {
			method: 'get'
		});
	}

	storeCurrentChallengePosition(currentChallengePosition) {
		axios(new UrlTemplate(this.options.storeCurrentChallengePositionUrl)
		.r(this.currentChallengePosition, currentChallengePosition)
		.url, {
			method: 'get'
		});
	}

	hasMemberEnoughMoney(amount, onTrueCallback, onFalseCallback) {
		axios(new UrlTemplate(this.options.checkGoldUrl)
		.r(this.gold, amount)
		.url, {
			method: 'get'
		}).then((response) => {
			var parsedResponse = response.data;

			if (parsedResponse.success) {
				onTrueCallback();
			} else {
				onFalseCallback();
			}
		});
	}

	callForMoneyTransaction(amount, tag) {
		axios(new UrlTemplate(this.options.callForMoneyTransactionUrl)
		.r(this.gold, amount)
		.r(this.goldTag, tag)
		.url, {
			method: 'get'
		});
	}

	saveHighscore(score, miniGameID) {
		axios(new UrlTemplate(this.options.saveHighScoreUrl)
		.r(this.score, score)
		.r(this.miniGameID, miniGameID)
		.url, {
			method: 'get'
		});
	}

	getGameContent(gameId, callback) {
		axios(new UrlTemplate(this.options.getGameContentUrl)
		.r(this.gameId, gameId)
		.url, {
			method: 'get'
		}).then((response) => {
			callback(response.data.gameContent);
		});
	}

	setGamePassed(gameId) {
		axios(new UrlTemplate(this.options.setGamePassedUrl)
		.r(this.gameId, gameId)
		.url, {
			method: 'get'
		});
	}

	resetGamesPassedInCategory(categoryNameTRKey) {
		axios(new UrlTemplate(this.options.resetGamesPassedInCategoryUrl)
		.r(this.categoryNameTRKey, categoryNameTRKey)
		.url, {
			method: 'get'
		});
	}

	awardTrophy(trophy, color) {
		if (typeof(color) === "undefined") {
			color = 0;
		}

		axios(new UrlTemplate(this.options.giveTrophyUrl)
		.r(this.trophyId, trophy.id)
		.r(this.trophyColor, color)
		.url, {
			method: 'get'
		});
	}
}
